import { editor } from 'monaco-editor';

/**
 * Databricks SQL theme for Monaco - matches universe editor theme
 */
export const databricksSqlTheme: editor.IStandaloneThemeData = {
  base: 'vs',
  inherit: true, // Inherit from VS to get base colors
  rules: [
    // SQL keywords - muted blue from universe editor
    { token: 'keyword', foreground: '0a6fbf' },
    { token: 'keyword.sql', foreground: '0a6fbf' },

    // SQL strings - red/orange
    { token: 'string', foreground: 'c72e0f' },
    { token: 'string.sql', foreground: 'c72e0f' },

    // SQL identifiers - default text color (will be overridden by decorations for tables)
    { token: 'identifier', foreground: '000000' },
    { token: 'identifier.sql', foreground: '000000' },
    { token: 'identifier.quoted.sql', foreground: '000000' },

    // SQL functions - orange like table names
    { token: 'support.function.sql', foreground: 'bc8e1a' },
    { token: 'predefined.sql', foreground: 'bc8e1a' },

    // SQL types
    { token: 'support.type.sql', foreground: '34a6ce' },
    { token: 'type.sql', foreground: '34a6ce' },

    // Constants
    { token: 'constant.language.sql', foreground: '5848f6' },
    { token: 'literal.sql', foreground: '5848f6' },

    // Numbers
    { token: 'number', foreground: '098658' },
    { token: 'constant.numeric', foreground: '098658' },
    { token: 'constant.numeric.sql', foreground: '098658' },

    // Comments
    { token: 'comment', foreground: '4c886b' },
    { token: 'comment.sql', foreground: '4c886b' },

    // Operators
    { token: 'operator', foreground: '687687' },
    { token: 'operator.sql', foreground: '687687' },

    // Delimiters
    { token: 'delimiter', foreground: '000000' },
  ],
  colors: {
    'editor.background': '#fafafa',
    'editor.lineHighlightBackground': '#f3f3fa',
    'editor.lineHighlightBorder': '#f3f3fa',
    'editorLineNumber.activeForeground': '#9769dc',
    'editor.wordHighlightBackground': '#57575713',
    'input.placeholderForeground': '#6b6b6b',
  },
};

/**
 * Dark theme variant
 */
export const databricksSqlDarkTheme: editor.IStandaloneThemeData = {
  base: 'vs-dark',
  inherit: true,
  rules: [
    // SQL keywords
    { token: 'keyword', foreground: '569CD6' },
    { token: 'keyword.sql', foreground: '569CD6' },

    // SQL strings
    { token: 'string', foreground: 'ce9178' },
    { token: 'string.sql', foreground: 'ce9178' },

    // SQL identifiers - default text color
    { token: 'identifier', foreground: 'd4d4d4' },
    { token: 'identifier.sql', foreground: 'd4d4d4' },
    { token: 'identifier.quoted.sql', foreground: 'd4d4d4' },

    // SQL functions
    { token: 'support.function.sql', foreground: 'd7ba7d' },
    { token: 'predefined.sql', foreground: 'd7ba7d' },

    // SQL types
    { token: 'support.type.sql', foreground: '4EC9B0' },
    { token: 'type.sql', foreground: '4EC9B0' },

    // Constants
    { token: 'constant.language.sql', foreground: '569CD6' },
    { token: 'literal.sql', foreground: '569CD6' },

    // Numbers
    { token: 'number', foreground: 'b5cea8' },
    { token: 'constant.numeric', foreground: 'b5cea8' },
    { token: 'constant.numeric.sql', foreground: 'b5cea8' },

    // Comments
    { token: 'comment', foreground: '6A9955' },
    { token: 'comment.sql', foreground: '6A9955' },

    // Operators
    { token: 'operator', foreground: 'd4d4d4' },
    { token: 'operator.sql', foreground: 'd4d4d4' },
  ],
  colors: {
    'editor.background': '#252526',
    'editor.lineHighlightBackground': '#3a3a3a',
    'editor.lineHighlightBorder': '#3a3a3a',
    'input.placeholderForeground': '#bfbfbf',
  },
};
